import * as dayjs from "dayjs";

export default (createdAt = new Date().getTime(), format = "MMM D, h:mm A") => {
  return dayjs(createdAt).format(format);
};
